export default __webpack_public_path__ + "static/orsusecase3-f0e5727050cdd333c39354cd9a36b509.jpg";